/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHeiScrollspySectionViewProps } from './hei-scrollspy-section';
import classnames from 'classnames';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';

export default (props: IHeiScrollspySectionViewProps) => {
    const {
        titleOnly,
        hrefAnchor,
        config: { sectionTitle, hideTitleHeading, className, sectionHeading },
        slots
    } = props;

    if (titleOnly) {
        return <a href={`#${hrefAnchor}`}>{sectionTitle ?? 'Untitled'}</a>;
    }

    const sectionContent = ArrayExtensions.firstOrDefault(slots.sectionContent);
    const floatingContent = ArrayExtensions.firstOrDefault(slots.floatingContent);

    return (
        <div className={classnames('hei-scrollspy-section', className)}>
            <div id={hrefAnchor} className='hei-scrollspy-section-trigger'></div>
            <div className='hei-scrollspy-section-main main-content-container'>
                {!hideTitleHeading && sectionTitle && <div className='section-main-title'>{sectionHeading || sectionTitle}</div>}
                {sectionContent}
            </div>
            {floatingContent && <div className='hei-scrollspy-section-side'>{floatingContent}</div>}
        </div>
    );
};
